type ApiServiceConfig = {
  apiUrl: string;
  firebaseEnv: string;
  chimeApiUrl?: string;
  env: string | undefined;
  isDevelopment?: boolean;
  isStaging?: boolean;
  isProduction?: boolean;
};

let config: ApiServiceConfig | null = null;

export function setConfig(userConfig: ApiServiceConfig) {
  config = {
    ...userConfig,
    isDevelopment: userConfig.env === "development",
    isStaging: userConfig.env === "staging",
    isProduction: userConfig.env === "production",
  };
}

export function getConfig(): ApiServiceConfig {
  if (!config) {
    throw new Error("App config has not been set yet");
  }
  return config;
}
